import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {z} from "zod/v4-mini"
import {vector2Like} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"
import {returnType as findBestMatchAlongSegmentReturnType} from "@app/textures/texture-editor/operator-stack/operators/tiling/node/find-best-match-along-segment/definition"
import {imageOpHalOptions} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/image-op-hal-types"

export const definition = {
    validation: {
        returns: z.object({
            waveLength: z.number(),
            energy: z.number(),
            details: findBestMatchAlongSegmentReturnType,
        }),
        parameters: z.object({
            imageOpHalOptions: imageOpHalOptions,

            sourceImage: anyImageOpResult,
            rayOrigin: vector2Like,
            rayTarget: vector2Like,
            minFeatureLength: z._default(z.number(), 32),
        }),
    },
}
